import {
    createStore,
    combineReducers,
    applyMiddleware,
    compose,
} from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { reducer as formReducer } from 'redux-form';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';

// Import reducers
import routerHistoryReducer from '../reducers/router-history/reducer';
import selectproductReducer from '../reducers/select-product/reducer';
import composeReportToolReducer from '../reducers/compose-report-tool/reducer';
import getContentReducer from '../reducers/get-content/reducer';

const basename = window.location.pathname;
// Get middleware for history
export const history = createBrowserHistory({ basename });

// Build middleware
const middleware = applyMiddleware(
    routerMiddleware(history),
    thunk,
);

// Combine the reducers
const reducers = {
    content: getContentReducer,
    selectproduct: selectproductReducer,
    selectedsections: composeReportToolReducer,
    form: formReducer,
    router: connectRouter(history),
    routerHistory: routerHistoryReducer,
};

let enhancer;

if (process.env.NODE_ENV === 'development') {
    enhancer = composeWithDevTools(
        middleware,
    );
} else {
    enhancer = compose(
        middleware,
    );
}

// Make our store with our reducers and middleware
const store = createStore(
    connectRouter(history)(combineReducers(reducers)),
    enhancer,
);

export default store;
